import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ContractRequestedMaterialDTO, RequestMaterialDTO, AwardDTO, TenderRequestedMaterialDTO, ContractDTO, LotDTO } from '../../api/plyca-dtos-v2';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DATEPIPE_DATE_FORMAT } from '../../../services/language.service';
import { FormConfig } from '../../components/forms/form.objects';
import { AppConfiguration } from '../../conf/app.configuration';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { TaskDTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import * as lodash from 'lodash';

export class ContractRequestedMaterialModel {
  dto: ContractRequestedMaterialDTO;
}

@Component({
  selector: 'award-material',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService, UIService]
})
export class ContractRequestedMaterialComponent
  extends BaseFormComponent<ContractRequestedMaterialDTO, ContractRequestedMaterialModel>
  implements AfterContentInit, OnDestroy, OnInit {

  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;

  public translate: TranslateService;

  private CRM: ContractRequestedMaterialDTO;
  private contract: ContractDTO;
  private readonly = false;


  updateMode = false;
  insertMode = false;
  showLotes = false;






  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    public ref: DynamicDialogRef
  ) {
    super(elem);

    this.windowHash = generateRandomIdentifier();
    this.readonly = dialogConfig['readonly'] ? dialogConfig['readonly'] : false;

    // Si se abre un evento existente llega en el context
    let context = dialogConfig['context'];
    this.contract = context['contract'];
    if (context) {
      if (context && context.element && context.element.identifier) {
        this.updateMode = true;
        this.CRM = context['element'];
      } else {
        this.insertMode = true;
        this.CRM = new ContractRequestedMaterialDTO();
      }

    } else {
      // Si no llegan los datos del evento es un evento nuevo
      this.CRM = new ContractRequestedMaterialDTO();
      this.insertMode = true;
    }

    this.task = dialogConfig?.data?.task;
  }

  // Metodos obligatorios
  dtoToModel(dto: ContractRequestedMaterialDTO): Observable<ContractRequestedMaterialModel> {
    let model = new ContractRequestedMaterialModel();

    if (JSON.stringify(dto) === '{}') {

      dto.contract = this.contract;
      dto.contract.division.identifier = getSimpleIdentifierFromString(this.contract.division.identifier);

    }

    model.dto = dto;
    if (dto.contract.contractLots) {
      this.showLotes = true;
    }

    model['ui'] = {};
    model['ui']['project'] = this.contract.division['project'];
    model['ui']['projectDes'] = this.contract.division['project'].identifier + ' ' + this.contract.division['project']?.contractFolderId;

    if (this.showLotes) {
      model['ui']['lotesDes'] = this.contract.contractLots.map((lot => { return lot.lot.lotId }))
      model['ui']['lotesDes'] = '' + model['ui']['lotesDes'] + '';


      model['ui']['lotNumberDes'] = this.contract.contractLots.map((lot => { return lot.lot.lotNumber }))
      model['ui']['lotNumberDes'] = '' + model['ui']['lotNumberDes'] + '';
    }

    if (this.task) {
      // se clona la configuracion para no modificarla con el interface
      dto['context'] = lodash.cloneDeep(this.task.work.context);

      dto.task = {} as TaskDTO;
      dto.task.identifier = this.task.identifier;

    }
    model.dto = dto;

    return of(model);
  }
  modelToDTO(model: ContractRequestedMaterialModel): ContractRequestedMaterialDTO {

    let dto = model.dto;
    dto.lote = new LotDTO();
    dto.lote.lotId = dto.awardRequestedMaterial.requestedMaterial.lot.lotNumber;
    /*
        let identifier = getSimpleIdentifierFromString(model.dto.requestedMaterial.identifier);
        delete dto.requestedMaterial;
        dto.requestedMaterial = new RequestMaterialDTO();
        dto.requestedMaterial.identifier = identifier;
    */
    // igual no hace falta por que no hay tablas
    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;
  }


  getTitle(model: ContractRequestedMaterialDTO): string {
    return model.identifier;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    return undefined;
  }

  getServiceURL(): string {
    return this.configuration.CONTRACT_REQUESTEDMATERIAL_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.CRM.identifier;
  }
  getFormSettingURL(): string {
    return 'requestedMaterial/ContractRequestedMaterialSettings.json';
  }

  initHeaderActions() {
    if (this.readonly === false) {
      this.subscribe(
        this.headerActionsService
          .addWindowAction(
            'General.save',
            'fas fa-lg fa-check',
            'btn-primary',
            true,
            this.windowHash
          )
        , (success) => {
          this.guardar();
        });
    }
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      (success) => {
        this.ref.close();
      }
    );
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;

    formConfig.readonly = this.readonly;

    formConfig.windowHash = this.windowHash;

    formConfig.functions.push({
      identifier: 'onChangSelectedMaterial',
      fn: this.onChangSelectedMaterial
    });

    return of(formConfig);
  }



  guardar() {
    this.subscribe(this.save(),

      (newEvent: ContractRequestedMaterialDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(
          this.translate.instant('RequestedMaterial.accion.save.ok'),
          this.translate.instant('General.info'),
          'success'
        );
        this.ref.close(newEvent);
      }


    );

  }

  onChangSelectedMaterial(model: ContractRequestedMaterialModel) {

    //  model.dto.requestedMaterial = model.dto.tenderRequestedMaterial.requestedMaterial;
  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);
  }
  ngOnDestroy() {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

}
